module.exports = __webpack_public_path__ + "img/receipt-bottom-none.bfa35f1e.jpg";